/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartworkingtitle4Inputs */

const en_eventaistartworkingtitle4 = /** @type {(inputs: Eventaistartworkingtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify is filling in your event`)
};

const de_eventaistartworkingtitle4 = /** @type {(inputs: Eventaistartworkingtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify füllt dein Event aus`)
};

/**
* | output |
* | --- |
* | "Pulsify is filling in your event" |
*
* @param {Eventaistartworkingtitle4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartworkingtitle4 = /** @type {((inputs?: Eventaistartworkingtitle4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartworkingtitle4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartworkingtitle4(inputs)
	return de_eventaistartworkingtitle4(inputs)
});
export { eventaistartworkingtitle4 as "eventAiStartWorkingTitle" }